'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Heading } from 'base-ui'

import { cmsExcludeEmptyString } from '../../cmsExcludeEmptyString'
import { useStoryblokStory } from '../../context/StoryblokStoryContext'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokTableOfContentsType } from '../../storyblok'

import { cmsGetTocItems } from './cmsGetTocItems'

export const StoryblokTableOfContents: FC<
  StoryblokComponentProps<StoryblokTableOfContentsType>
> = ({ blok }) => {
  const { story } = useStoryblokStory()

  const tocItems = useMemo(() => cmsGetTocItems(story.content), [story.content])

  if (tocItems.length <= 1) {
    return null
  }

  const { heading } = blok

  return (
    <nav {...storyblokEditable(blok)}>
      <Heading className="mb-6" level={2} size="l">
        {cmsExcludeEmptyString(heading) ?? (
          <FormattedMessage id="general.label.category.ToC" />
        )}
      </Heading>
      <ol className="flex flex-wrap gap-x-3 gap-y-4">
        {tocItems.map((item) => (
          <li className="max-w-full" key={item.anchor}>
            <Button
              className="max-w-full"
              color="secondary"
              href={`#${item.anchor}`}
              size="small"
            >
              <span className="truncate">{item.text}</span>
            </Button>
          </li>
        ))}
      </ol>
    </nav>
  )
}
